/* eslint-disable react/no-danger */
import React, { useId } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import { IconExternalLink } from '@/app/components/hotel-detail/common/icons';
import { NewTabDescription, RankingBoxContainer } from './styled';

const NEW_TAB_DESCRIPTION_KEY = 'vacation.common.opens_in_new_tab';

type RankingBoxProps = {
  localization: Localization;
  hasPreselectedFlight?: boolean;
  variant?: 'default' | 'evolution';
};

const RankingBox = ({ localization, hasPreselectedFlight = false, variant = 'default' }: RankingBoxProps) => {
  const { t, translationDictionary } = useTranslation();
  const newTabDescriptionId = useId();
  if (!localization.rankingLink) return null;
  return (
    <RankingBoxContainer hasPreselectedFlight={hasPreselectedFlight} variant={variant}>
      <span
        dangerouslySetInnerHTML={{
          __html: t('vacation.oss.indexcollapsed.ranking').replace(
            /__(.*?)__/g,
            `<a href="${localization.rankingLink}" target="_blank" rel="noreferrer" title="$1" aria-describedby="${newTabDescriptionId}">$1</a> `
          ),
        }}
      />
      {/* MPH-1471: the link itself says it opens a new tab, so the icon next to it is decorative. */}
      <NewTabDescription id={newTabDescriptionId}>
        {/* The dictionary is checked first so that the English fallback does not report a missing translation. */}
        {translationDictionary[NEW_TAB_DESCRIPTION_KEY] ? t(NEW_TAB_DESCRIPTION_KEY) : 'Opens in a new tab'}
      </NewTabDescription>
      <IconExternalLink alt="" />
    </RankingBoxContainer>
  );
};

export default RankingBox;
